import moment from 'moment'

//  Cut off grad year at june 1 of this year
const currentGradYear = moment().year() + ( moment().month() >= 6 ? 1 : 0)

export default currentGradYear